import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { OrderDataResolver } from '../resolvers';
import { OrdersRefundControllerModule } from './controllers/OrdersRefundController';

export const OrdersRefundView = angular
  .module('acme.view.application.orders.refund', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    OrdersRefundControllerModule
  ])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const ordersRefund = {
      name: 'application.orders.refund',
      url: '/:orderId/refund',
      views: {
        'subview-main': {
          controller: 'OrdersRefundController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/orders/refund/refund.tpl.html',
        },
      },
      data: {
        pageTitle: 'Cancel Order and Refund',
        permissions: ['REFUNDS_EXECUTE'],
      },
      resolve: {
        OrderData: OrderDataResolver(),
      },
    };

    $stateProvider.state(ordersRefund);
  }).name;
